import { render } from "./login-modal.vue?vue&type=template&id=d9a53dd6&scoped=true"
import script from "./login-modal.vue?vue&type=script&lang=js"
export * from "./login-modal.vue?vue&type=script&lang=js"

import "./login-modal.vue?vue&type=style&index=0&id=d9a53dd6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2433923721/src/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9a53dd6"]])

export default __exports__